import { c as _c } from "react-compiler-runtime";
import { useMemo } from 'react';
import { useSelectionSelector } from '../../redux/reduxHooks';
import { getIsQuerySelected, getSelectedRowIds } from '../../selection/redux/selectionSlice';
export function useShowSelectQuery(rows, getRowId, canSelectAllRecords, isBulkActionsRedesignEnabled, totalRowCount) {
  const $ = _c(6);
  const isQuerySelected = useSelectionSelector(getIsQuerySelected);
  let t0;
  if ($[0] !== getRowId || $[1] !== rows) {
    t0 = rows.map(getRowId);
    $[0] = getRowId;
    $[1] = rows;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const currentPageRowIds = t0;
  const isCurrentPageSelected = useIsCurrentPageSelected(currentPageRowIds);
  const hasMorePages = totalRowCount > currentPageRowIds.length;
  const canSelectQuery = canSelectAllRecords && isCurrentPageSelected && hasMorePages;
  const showSelectQueryRow = canSelectQuery && !isBulkActionsRedesignEnabled;
  const showSelectQueryInBulkActionsContainer = canSelectQuery && !isQuerySelected && isBulkActionsRedesignEnabled;
  let t1;
  if ($[3] !== showSelectQueryInBulkActionsContainer || $[4] !== showSelectQueryRow) {
    t1 = {
      showSelectQueryRow,
      showSelectQueryInBulkActionsContainer
    };
    $[3] = showSelectQueryInBulkActionsContainer;
    $[4] = showSelectQueryRow;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
}
function useIsCurrentPageSelected(currentPageRowIds) {
  const $ = _c(5);
  const selectedRowIds = useSelectionSelector(getSelectedRowIds);
  if (currentPageRowIds.length === 0) {
    return false;
  }
  let t0;
  if ($[0] !== currentPageRowIds || $[1] !== selectedRowIds) {
    let t1;
    if ($[3] !== selectedRowIds) {
      t1 = rowId => selectedRowIds.has(rowId);
      $[3] = selectedRowIds;
      $[4] = t1;
    } else {
      t1 = $[4];
    }
    t0 = currentPageRowIds.every(t1);
    $[0] = currentPageRowIds;
    $[1] = selectedRowIds;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
}